/* eslint-disable no-param-reassign */
import { normalize } from 'normalizr'
import { Schemas } from '@redux/schema'
import { updateEntities, deleteEntity } from '@redux/entities'

import api from '@functions/api'

import { handleError } from '../utils'

const FETCH_REQUEST = 'contenthouse/serviceJobUser/FETCH_REQUEST'
const FETCH_SUCCESS = 'contenthouse/serviceJobUser/FETCH_SUCCESS'
const FETCH_FAILURE = 'contenthouse/serviceJobUser/FETCH_FAILURE'

const CREATE_REQUEST = 'contenthouse/serviceJobUser/CREATE_REQUEST'
const CREATE_SUCCESS = 'contenthouse/serviceJobUser/CREATE_SUCCESS'
const CREATE_FAILURE = 'contenthouse/serviceJobUser/CREATE_FAILURE'

const UPDATE_REQUEST = 'contenthouse/serviceJobUser/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'contenthouse/serviceJobUser/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'contenthouse/serviceJobUser/UPDATE_FAILURE'

const DELETE_REQUEST = 'contenthouse/serviceJobUser/DELETE_REQUEST'
const DELETE_SUCCESS = 'contenthouse/serviceJobUser/DELETE_SUCCESS'
const DELETE_FAILURE = 'contenthouse/serviceJobUser/DELETE_FAILURE'

// Initial State
const initialState = {
  creating: false,
  deleting: false,
  errors: [],
  loaded: false,
  loading: false,
  updating: false,
}

// Actions
export function fetchRequest(){
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload = {}){
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

export function deleteRequest(){
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(){
  return {
    type: DELETE_SUCCESS,
  }
}

export function deleteFailure(errors = []){
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

export function loadServiceJobUsers(options){
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api('/v1/service-job-users', options)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.SERVICE_JOB_USER_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess(data))

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, errors }
      })
    return promise
  }
}

export function loadServiceJobUser(id, dispatch){
  const includes = ['serviceJobUserRole', 'user']
  const options = {
    includes: includes.join(','),
  }

  dispatch(fetchRequest())

  const promise = api(`/v1/service-job-users/${id}`, options)
    .then(({ data }) => {
      const normalizedJson = normalize(data, Schemas.SERVICE_JOB_USER)
      dispatch(updateEntities(normalizedJson))
      dispatch(fetchSuccess(data))

      return { success: true, data }
    })
    .catch((data) => {
      const errors = handleError(data)
      dispatch(fetchFailure(errors))

      return { success: false, errors }
    })

  return promise
}

export function assignServiceJobUser(serviceJobUser, options){
  const config = {
    method: 'POST',
    data: serviceJobUser,
  }

  if (options && options.includes){
    if (!options.includes.includes('serviceJobUserRole')){
      options.includes.push('serviceJobUserRole')
    }
    if (!options.includes.includes('user')){
      options.includes.push('user')
    }
    options.includes = options.includes.join(',')
  } else options = { ...options, includes: 'serviceJobUserRole,user' }

  return (dispatch) => {
    dispatch(createRequest())

    const promise = api('/v1/service-job-users', options, config)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.SERVICE_JOB_USER)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(createFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function updateServiceJobUser(serviceJobUser, options){
  const config = {
    method: 'PUT',
    data: serviceJobUser,
  }

  if (options && options.includes){
    if (!options.includes.includes('serviceJobUserRole')){
      options.includes.push('serviceJobUserRole')
    }
    if (!options.includes.includes('user')){
      options.includes.push('user')
    }
    options.includes = options.includes.join(',')
  } else options = { ...options, includes: 'serviceJobUserRole,user' }

  return (dispatch) => {
    dispatch(updateRequest())

    const promise = api(`/v1/service-job-users/${serviceJobUser.id}`, options, config)
    .then(({ data }) => {
      const normalizedJson = normalize(data, Schemas.SERVICE_JOB_USER)
      dispatch(updateEntities(normalizedJson))
      dispatch(updateSuccess())

      return { success: true, data }
    })
    .catch((data) => {
      const errors = handleError(data)
      dispatch(updateFailure(errors))

      return { success: false, errors }
    })

    return promise
  }
}

export function deleteServiceJobUser(serviceJobUser){
  const config = {
    method: 'DELETE',
  }

  return (dispatch) => {
    dispatch(deleteRequest())

    const promise = api(`/v1/service-job-users/${serviceJobUser.id}`, {}, config)
      .then(({ data }) => {
        const normalizedJson = normalize(serviceJobUser, Schemas.SERVICE_JOB_USER)
        dispatch(deleteEntity(normalizedJson))
        dispatch(deleteSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(deleteFailure(errors))

        return { success: false, errors }
      })
    return promise
  }
}

export default function reducer(state = initialState, action = {}){
  const { type, payload, errors } = action
  switch (type){
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        errors: [],
        loaded: true,
        loading: false,
        result: payload,
      }
    case FETCH_FAILURE:
      return {
        ...state,
        errors,
        loaded: false,
        loading: false,
      }
    case CREATE_REQUEST:
      return {
        ...state,
        creating: true,
      }
    case CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        errors: [],
      }
    case CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        errors,
      }
    case UPDATE_REQUEST:
      return {
        ...state,
        updating: true,
      }
    case UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        errors: [],
      }
    case UPDATE_FAILURE:
      return {
        ...state,
        updating: false,
        errors,
      }
    case DELETE_REQUEST:
      return {
        ...state,
        deleting: true,
      }
    case DELETE_SUCCESS:
      return {
        ...state,
        deleting: false,
        errors: [],
      }
    case DELETE_FAILURE:
      return {
        ...state,
        deleting: false,
        errors,
      }
    default:
      return state
  }
}
